import { render, staticRenderFns } from "./BaseTab.vue?vue&type=template&id=4e7bc864"
import script from "./BaseTab.vue?vue&type=script&lang=ts"
export * from "./BaseTab.vue?vue&type=script&lang=ts"
import style0 from "./BaseTab.vue?vue&type=style&index=0&id=4e7bc864&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports